import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import ExploreProjects from "../components/common/ExploreProjects";
import SponsorBanner from "../components/common/SponserBanner";

import ProfessionalsList from "../components/professionals/ProfessionalsList";
import {
  getAllProfessionals,
  getProfessionalById,
} from "../service/MainService";

const Professionals = () => {
  const navigate = useNavigate();
  const [professionals, setProfessionals] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(0);
  const topRef = useRef(null);
  const [userCount, setUserCount] = useState(null);
  const [filters, setFilters] = useState({});

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const professionalsData = await getAllProfessionals(
          currentPage,
          10,
          filters
        );
        setProfessionals(professionalsData.Result);
        setUserCount(professionalsData.TotalUsers);
        setLoading(false);
      } catch (error) {
        setError(error.message);
        setLoading(false);
      }
    };
    fetchData();
  }, [currentPage, filters]);

  const handlePageChange = (page, e) => {
    e.preventDefault();
    setCurrentPage(page);
  };


  const handleFilterChange = (selectedFilters) => {
    setFilters(selectedFilters);
    setCurrentPage(0);
  };

  const navigateToProfessionalDetail = async (userId) => {
    try {
      const token = localStorage.getItem("accessToken");
      const userDetails = await getProfessionalById(userId, token);
      navigate(`/professionals/${userId}`, {
        state: { userDetails },
      });
    } catch (error) {
      console.error("Error fetching project details:", error);
    }
  };

  const handleFilterChangeIndustry = (selectedFilters) => {
    setFilters({ industry: selectedFilters });
  };

  

  const industry = [
    "Architecture",
    "Civil Engineering",
    "Environmental and Sustainability Design",
    "Landscape Architecture",
    "Mechanical Engineering",
    "Lighting Design",
    "Interior Design",
    "Geotechnical Engineering",
    "Acoustic Design",
    "Electrical Engineering",
    "Construction and Building Industry",
    "Technology and Information Systems in Architecture",
    "Structural Engineering",
    "Urban and Regional Planning",
    "Accessibility and Inclusive Design",
  ];
  return (
    <>
      <div className="lg:px-40">
        <ProfessionalsList
          professionals={professionals}
          userCount={userCount}
          loading={loading}
          error={error}
          topRef={topRef}
          currentPage={currentPage}
          handleFilterChange={handleFilterChange}
          navigateToProfessionalDetail={navigateToProfessionalDetail}
          handlePageChange={handlePageChange}
        />
      </div>
      <div className="bg-gray-100 py-5 lg:px-40">
        <ExploreProjects
          title={"Explore Professionals"}
          explore={industry}
          onCategorySelect={handleFilterChangeIndustry}
        />
      </div>
      <div className="lg:px-40">
        <SponsorBanner />
      </div>
    </>
  );
};

export default Professionals;
